import { IAccountProps } from '@/entities/Account'
import { IMenuProps } from '@/entities/Menu'

export const Types = {
  layout: 'layout',
  loading: 'loading',
  signup: 'signup',
  progress: 'progress',
  errors: 'errors',
  drawer: 'drawer',
  alert: 'alert',
  current: 'current',
  redirect: 'redirect',
  from: 'from',
  back: 'back',
  toolbar: 'toolbar',
  extension: 'extension',
  initialize: 'initialize',
  bottom: 'bottom',
  bottomHeight: 'bottomHeight',
  headerHeight: 'headerHeight',
  observer: 'observer',
  updated: 'updated'
}

export const path = 'app/'

export class Layout implements FluxStandardAction<string> {
  type = path + Types.layout
  constructor(public payload: string) {}
}

export class Loading implements FluxStandardAction<boolean> {
  type = path + Types.loading
  constructor(public payload: boolean) {}
}

export class Signup implements FluxStandardAction<IAccountProps> {
  type = path + Types.signup
  constructor(public payload: IAccountProps) {}
}

export class Progress implements FluxStandardAction<number> {
  type = path + Types.progress
  constructor(public payload: number) {}
}

export class Errors implements FluxStandardAction<any> {
  type = path + Types.errors
  constructor(public payload: any) {}
}

export class Drawer implements FluxStandardAction<boolean | null> {
  type = path + Types.drawer
  constructor(public payload: boolean | null) {}
}

export class Alert implements FluxStandardAction<boolean | null> {
  type = path + Types.alert
  constructor(public payload: boolean | null) {}
}

export class Current implements FluxStandardAction<IMenuProps | undefined> {
  type = path + Types.current
  constructor(public payload: IMenuProps | undefined) {}
}

export class Redirect implements FluxStandardAction<string | null> {
  type = path + Types.redirect
  constructor(public payload: string | null) {}
}

export class From implements FluxStandardAction<string | null | undefined> {
  type = path + Types.from
  constructor(public payload: string | null | undefined) {}
}
export class Back implements FluxStandardAction<string | null | undefined> {
  type = path + Types.back
  constructor(public payload: string | null | undefined) {}
}

export class Toolbar implements FluxStandardAction<boolean> {
  type = path + Types.toolbar
  constructor(public payload: boolean) {}
}

export class Extension implements FluxStandardAction<boolean> {
  type = path + Types.extension
  constructor(public payload: boolean) {}
}

export class Initialize implements FluxStandardAction<string | null> {
  type = path + Types.initialize
  constructor(public payload: string | null) {}
}

export class Bottom implements FluxStandardAction<boolean> {
  type = path + Types.bottom
  constructor(public payload: boolean) {}
}

export class BottomHeight implements FluxStandardAction<string> {
  type = path + Types.bottomHeight
  constructor(public payload: string) {}
}

export class HeaderHeight implements FluxStandardAction<string> {
  type = path + Types.headerHeight
  constructor(public payload: string) {}
}

export class Observer implements FluxStandardAction<any> {
  type = path + Types.observer
  constructor(public payload: any) {}
}

export class Updated implements FluxStandardAction<boolean> {
  type = path + Types.updated
  constructor(public payload: boolean) {}
}
